import { Component } from '@angular/core';

@Component({
  selector: 'app-subscription-payment-failure-dialog',
  templateUrl: './subscription-payment-failure-dialog.component.html',
  styleUrls: ['./subscription-payment-failure-dialog.component.scss'],
  standalone: false
})
export class SubscriptionPaymentFailureDialogComponent {}
